"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getSkill = function getSkill(skill) {
  return skill ? 1 : 0;
};

// a negative number indicates a user has not selected a skill
// but the job has.
//
// A positive number, the reverse.
var getValue = function getValue(userSkill, jobSkill) {
  var constants = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var userValue = getSkill(userSkill);
  var jobValue = getSkill(jobSkill);
  var value = userValue - jobValue;

  if (value === 0 && jobValue > 0) {
    // the user and the job both match for the skill!
    return constants.USER_AND_JOB_SKILL_MATCH_BOOST;
  } else if (value <= 0) {
    // the job wants a skill the user doesn't have
    if (jobSkill && jobSkill.critical) {
      return constants.MISSING_CRITICAL_SKILL_PENALTY;
    }

    return constants.MISSING_SKILL_PENALTY;
  }

  // the user wants a skill the job doesn't offer
  return constants.JOB_SKILL_NOT_PRESENT_PENALTY;
};

exports.default = getValue;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/utils/match/skills/getValue.js
// module id = 1319
// module chunks = 0